import { observable, action, runInAction } from 'mobx';
import { isEmpty, cloneDeep } from 'lodash';
import localforage from 'localforage';
import Cookies from 'js-cookie';

import ResearchService from '@service/industry-research';
import moIndex from '../../store/index';
import Service from '@service/index';
import apiGet from '@api/api-get';
import moUser from '@store/user';
import moSkin from '@store/skin';
import { toggleLoading, toggleAddModal, toggleConcatModal } from "@store/index";

const moTypicalPosition = observable({
  jobList: <any[]>[],
  jobCount: 0, // 职位数量
  categoryCount: 0, // 职能数量
});

const initTypicalPosition = action(async (res: any) => {
  let arr: any[] = [];
  let jobCount = 0;
  let categoryCount = 0;
  // const params = { industry: moIndex.industry.code };
  // const res: any = await ResearchService.typicalJobs(params);
  if (isEmpty(res)) {
    jobCount = 0;
    categoryCount = 0;
    arr = [];
  } else {
    jobCount = res.job_count;
    categoryCount = res.category_count;
    arr = res.list;
  }
  runInAction(() => {
    moTypicalPosition.jobList = arr;
    moTypicalPosition.jobCount = jobCount;
    moTypicalPosition.categoryCount = categoryCount;
  });
});

// 选择职位
// TODO: 典型职位 - 选择职位
const onJob = action((child: any, item: any) => {
  console.log('child -- ', child);
  console.log('item -- ', item);
});

// 查看全部
const lookAll = action(() => {
  const { industry } = moIndex;
  // console.log(industry.code,window.location.pathname);
  const url = encodeURIComponent(window.location.pathname)
  window.location.href=`/market/multi-report?industry=${industry.code}&backUrl=${url}`
  // localStorage.setItem('jobname', industry.name);
  // window.location.href = '/market/result?refresh=false';
});

const toReport = action(async (backUrl: string, arr: any[], code: number | string) => {
  // const { isLogin } = moUser;
  const newUrl = encodeURIComponent(backUrl);
  const urlName = `/market/single-report?backUrl=${newUrl}&industry=${code}`;
  window.location.href = urlName;
});

export default moTypicalPosition;
export { initTypicalPosition, onJob, lookAll, toReport };
